module.exports = __webpack_public_path__ + "img/zhibo.f5e78ed.gif";